import { useQuery } from '@tanstack/react-query';
import {
  GET_APP_INIT_DETAILS_MESSAGE_TYPE,
  getAppInitDetails,
} from 'api/get-app-init-details';
import camelCaseKeys from 'camelcase-keys';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { useGetUserProfile } from './use-get-user-profile.hook';

export const useGetAppInitDetails = () => {
  const { systemId } = usePatientPortalContext();
  const { data: userProfile } = useGetUserProfile();
  const userId = userProfile?.userId ?? '';

  return useQuery({
    queryKey: [GET_APP_INIT_DETAILS_MESSAGE_TYPE, systemId, userId],
    queryFn: () => getAppInitDetails(systemId, userId),
    select: (data) => camelCaseKeys(data, { deep: true }),
    enabled: Boolean(userId),
  });
};
